import {EVENT_PREFIX} from '../../../helpers';

export default (instanceKey, stateKey) => ({
  ...{
    type: `${EVENT_PREFIX}_RESET_SUBMITTING`
  },
  instanceKey,
  stateKey
});
